import * as ArrayUtilities from './array';
import * as DatabaseUtilities from './database';
import * as DateUtilities from './date';
import * as DermloopUrlUtilities from './dermloop-url';
import * as ImageUtilities from './image';
import * as NumberUtilities from './number';
import * as ObjectUtilities from './object';
import * as PhonenumberUtilities from './phonenumber/validate';
import * as StringUtilities from './string';
import * as TreeUtilities from './tree';

export const nameof = <T>(name: Extract<keyof T, string>): string => name;
export * from './class-validator';
export * from './date/date-range';
export {
  ArrayUtilities,
  DatabaseUtilities,
  DateUtilities,
  DermloopUrlUtilities,
  ImageUtilities,
  NumberUtilities,
  ObjectUtilities,
  PhonenumberUtilities,
  StringUtilities,
  TreeUtilities,
};
export * from './clinical/clinical-form-permissions';
